import { Virtuoso } from 'react-virtuoso';
import { ConnectedEventInfo } from 'src/components/Events/ConnectedEventInfo';
import { PosDropdown, PosDropdownItem } from 'src/core/POS/PosDropdown';
import { vars } from 'src/core/themes';
import { IconsFill, MoreIcon } from 'src/svgs/Viagogo';

import { OnSaleEventCatchUpCardProps } from './OnSaleEventCatchUpCard.types';

export function OnSaleEventCatchUpDropdown({
  cardProps,
}: {
  cardProps: OnSaleEventCatchUpCardProps[];
}) {
  return (
    <PosDropdown
      key="event-catchup-dropdown"
      trigger={
        <div style={{ padding: `0 ${vars.spacing.sm} 0 ${vars.spacing.xxs}` }}>
          <MoreIcon withHoverEffect fill={IconsFill.textBrand} align="middle" />
        </div>
      }
      align="end"
    >
      <Virtuoso
        style={{ height: '100vh', width: '650px', overflowX: 'hidden' }}
        totalCount={cardProps.length}
        data={cardProps}
        itemContent={(_, props) => <OnSaleEventCatchUpDrodownItem {...props} />}
      />
    </PosDropdown>
  );
}

function OnSaleEventCatchUpDrodownItem({
  event: onSaleEvent,
  isActive,
  onClick,
}: OnSaleEventCatchUpCardProps) {
  const { event, venue, performer } = onSaleEvent;

  return (
    <PosDropdownItem
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }}
      style={{
        backgroundColor: isActive ? vars.color.backgroundHighlight : '',
      }}
    >
      <ConnectedEventInfo
        showEventDateTbd
        event={event}
        performer={performer}
        venue={venue}
        slimMode
      />
    </PosDropdownItem>
  );
}
